import { sendTrackEvent } from "@sinch/bus";
import { useEffect } from "react";
import { getLocalStorage, setLocalStorage } from "../helpers/localStorage";
import { APP_NAME } from "../portals/constants";
import { EVENT_NAME } from "./rudderstack/createRudderstackEvent";

export const useLoginEvent = (isListenerSet: boolean) => {
  useEffect(() => {
    const eventSent = getLocalStorage(
      "userLoginEventSent",
      (x): x is boolean => typeof x === "boolean",
      false
    );

    if (isListenerSet && !eventSent) {
      sendTrackEvent({
        name: EVENT_NAME.USER_LOGIN,
        appName: APP_NAME.toLowerCase(),
        purposes: ["Analytical"],
      });
      // use locale storage as it gets wiped on logout
      setLocalStorage("userLoginEventSent", true);
    }
  }, [isListenerSet]);
};
